// Corrected import statement
import Axios, { REQUEST_METHOD } from "../axios";

export function apiDeleteSkitIdFromSourceIdAction({ skitId }) {
  console.log("API call to delete skit with ID:", skitId); // Log skitId here
  return Axios.fetch({
    url: `skits/delete-skit-record-and-related-records-s3bucket/${skitId}`, // The skitId is interpolated into the URL so since it is dynamic put it at the end This way, the :skitId is a dynamic segment in the URL that will match the ID of the skit you want to delete.
    method: REQUEST_METHOD.DELETE,
  });
}

export function apiFetchSkitById({ skitId }) {
  return Axios.fetch({
    url: `skits/fetch-skitid/${skitId}`, // The skitId is interpolated into the URL so since it is dynamic put it at the end This way, the :skitId is a dynamic segment in the URL that will match the ID of the skit you want to delete.
    method: REQUEST_METHOD.GET,
  });
}

export function apiFetchTrendingSkits(offset = 0, limit = 6, categoryId) {
  return Axios.fetch({
    url: "skits/trending-skits",
    method: REQUEST_METHOD.GET,
    params: { offset, limit, categoryId },
  });
}

export function apiFetchPopularSkits(offset = 0, limit = 6, categoryId) {
  return Axios.fetch({
    url: "skits/popular-skits",
    method: REQUEST_METHOD.GET,
    params: { offset, limit, categoryId },
  });
}

export function apiFetchSkitsForSkitsListingPage(
  offset = 0,
  limit = 6,
  categoryId = null
) {
  return Axios.fetch({
    url: "skits/skits-listing-page",
    method: REQUEST_METHOD.GET,
    params: { offset, limit, categoryId },
  });
}

// Fetch weekly chart by default metric (claps)
export async function apiFetchTopWeeklySkitChart({
  offset = 0,
  limit = 10,
  categoryid,
  week,
  year,
}) {
  try {
    const response = await Axios.fetch({
      url: "/skits/get-top-weekly-skit-chart", // default: claps
      method: REQUEST_METHOD.GET,
      params: {
        offset,
        limit,
        categoryid,
        weekNum: week, // if not provided, backend sets the latest week for current year
        year,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching top weekly skit chart:", error);
    return { success: false, data: null };
  }
}

// Fetch weekly chart by ratings
export async function apiFetchTopWeeklySkitChartRatings({
  offset = 0,
  limit = 10,
  categoryid,
  week,
  year,
}) {
  try {
    const response = await Axios.fetch({
      url: "/skits/get-top-weekly-skit-chart-ratings", // separate endpoint for ratings
      method: REQUEST_METHOD.GET,
      params: {
        offset,
        limit,
        categoryid,
        weekNum: week, // if not provided, backend sets defaults
        year,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching top weekly skit chart ratings:", error);
    return { success: false, data: null };
  }
}

/**
 * Search skits by title (fuzzy match)
 * @param {{ title: string, limit?: number, offset?: number, categoryId?: number|null }} opts
 */
export function apiSearchSkitsByTitle({
  title,
  limit = 10,
  offset = 0,
  categoryId = null,
}) {
  return Axios.fetch({
    url: "skits/search-by-skit-title", // your new backend endpoint
    method: REQUEST_METHOD.GET,
    params: { title, limit, offset, categoryId },
  });
}

// protected branches and checks notifications
export function apiReportSkit({ loggedInAccountHolderId, skitId, reason }) {
  return Axios.fetch({ // to do test this one 
    url: "/skits/report-skit",
    method: REQUEST_METHOD.POST,
    data: { loggedInAccountHolderId, skitId, reason },
  });
}

export const apiFetchRatedSkitsForCurrentUserDashboard = async (
  loggedInAccountHolderId, // will be sourceId on the backend
  limit = 10,
  offset = 0
) => {
  return Axios.fetch({
    url: `/skits/${loggedInAccountHolderId}/rated-skits`,
    method: REQUEST_METHOD.GET,
    params: { limit, offset },
  });
};

export function apiRewardSkitSubscriberPromo({
  loggedInAccountHolderId,
  targetId,
}) {
  return Axios.fetch({
    url: `/activity/bump-last-viewed-skit-after-subscribed-promo/${loggedInAccountHolderId}`,
    method: REQUEST_METHOD.POST,
    data: { targetId },
  });
}

export default {
  apiSearchSkitsByTitle,
  apiReportSkit,
  apiFetchTopWeeklySkitChart,
  apiFetchTopWeeklySkitChartRatings,
  apiFetchPopularSkits,
  apiFetchTrendingSkits,
  apiFetchSkitsForSkitsListingPage,
  apiRewardSkitSubscriberPromo,
  apiFetchRatedSkitsForCurrentUserDashboard,
  apiDeleteSkitIdFromSourceIdAction,
  apiFetchSkitById,
};
